export default "__VITE_ASSET__ac2f265e__"